export default "gce.logo2ae85d8704b1d6b8.png"